import '@fontsource-variable/manrope';
import '@fontsource-variable/plus-jakarta-sans';
import '@/shared/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { clearChunkReloadState, isChunkLoadError, recoverFromChunkLoadError } from '@/shared/lib';
import { App } from './app';

// Stale chunks after a deploy: reload once (same recovery as the production client).
window.addEventListener('load', clearChunkReloadState);
window.addEventListener('error', (event) => {
  if (isChunkLoadError(event.error)) recoverFromChunkLoadError();
});
window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) {
    event.preventDefault();
    recoverFromChunkLoadError();
  }
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
